/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductConversionFieldDto } from '../../models/backend-advanced-product-conversion-field-dto';
import { BackendAdvancedProductConversionFieldRequestDto } from '../../models/backend-advanced-product-conversion-field-request-dto';

export interface SalesAdvancedProductConversionFieldsCreate$Params {
  body: BackendAdvancedProductConversionFieldRequestDto;
}

export function salesAdvancedProductConversionFieldsCreate(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductConversionFieldsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductConversionFieldsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductConversionFieldDto>;
    }),
  );
}

salesAdvancedProductConversionFieldsCreate.PATH = '/api/sales/advanced-product-conversion-fields/';
